import React from 'react';
import SEO from '../common/SEO';
import ColorSwitcher from '../elements/switcher/ColorSwitcher';
import FooterOne from '../common/footer/FooterOne';
import CtaLayoutOne from '../component/cta/CtaLayoutOne';
import ServicePropOne from '../component/service/ServicePropOne';
import SectionTitle from '../elements/section-title/SectionTitle';
import BannerFive from '../component/banner/BannerFive';
import HeaderFour from '../common/header/HeaderFour';
import { useLanguage } from '../context/LanguageContext';
import { Features } from '../assets/features/Features';

const CorporateAgency = () => {
    const { language } = useLanguage();

    return (
        <>
        <SEO title="Fiel Carga - Transportes e Mudanças"/>
        <ColorSwitcher />
        <main className="main-wrapper">
        <HeaderFour />
        <BannerFive />

        <div className="section section-padding">
            <div className="container">
            <SectionTitle 
                subtitle={Features.SERVICES.SECTION_SUBTITLE[language]}
                title={Features.SERVICES.SECTION_TITLE[language].replace('\n', '<br>')}
                description=""
                textAlignment="heading-left mb--20 mb_md--70"
                textColor=""
            />
                <div className="row">
                    <ServicePropOne colSize="col-lg-4" serviceStyle="service-style-2" itemShow="3" marginTop="yes"/>
                </div>
            </div>
            <ul className="shape-group-7 list-unstyled">
                <li className="shape shape-1"><img src={process.env.PUBLIC_URL + "/images/others/circle-2.png"} alt="circle" /></li>
                <li className="shape shape-2"><img src={process.env.PUBLIC_URL + "/images/others/bubble-2.png"} alt="Line" /></li>
                <li className="shape shape-3"><img src={process.env.PUBLIC_URL + "/images/others/bubble-1.png"} alt="Line" /></li>
            </ul>

        </div>
        <CtaLayoutOne />
        <FooterOne />
        </main>
        </>
    )
}

export default CorporateAgency;